<nz-layout>
  <nz-header>
    <nz-tabset nzType="card" [nzTabBarExtraContent]="extraTemplate">
      <nz-tab [nzTitle]="titleTemplate">
        <ng-template #titleTemplate>
          <div style="display: flex; align-items: center;">
            <button nz-button nzType="text" (click)="backTo()" style="margin-right: 8px; padding: 0;">
              <span nz-icon nzType="arrow-left" nzTheme="outline" style="font-size: 16px; color: #c0142c;"></span>
            </button>
            <span>Checklists</span>
          </div>
        </ng-template>
      </nz-tab>
    </nz-tabset>
    <ng-template #extraTemplate>
      <button nz-button nzType="default" (click)="clearAllFilters()">Limpar Filtros</button>
      <button nz-button nzType="primary" (click)="exportToPdf()" style="margin-left: 8px;">Exportar para PDF</button>
    </ng-template>
  </nz-header>
  <nz-content>
    <nz-table #sortTable [nzShowPagination]="false" [nzData]="checklistHeaderFound">
      <thead>
        <tr>
          <th nzWidth="10%" nzCustomFilter>
            ID
            <nz-filter-trigger [nzActive]="filterConditions['id']?.length > 0" [nzDropdownMenu]="idMenu">
              <i nz-icon nzType="filter" nzTheme="fill"></i>
            </nz-filter-trigger>
          </th>
          <th nzWidth="20%" nzCustomFilter>
            Modelo
            <nz-filter-trigger [nzActive]="filterConditions['model']?.length > 0" [nzDropdownMenu]="modelMenu">
              <i nz-icon nzType="filter" nzTheme="fill"></i>
            </nz-filter-trigger>
          </th>
          <th nzWidth="20%" nzCustomFilter>
            Chassis
            <nz-filter-trigger [nzActive]="filterConditions['chassis']?.length > 0" [nzDropdownMenu]="chassisMenu">
              <i nz-icon nzType="filter" nzTheme="fill"></i>
            </nz-filter-trigger>
          </th>
          <th nzWidth="10%" [nzFilters]="typeFilters" (nzFilterChange)="onFilterChange('type', $event)">Tipo</th>
          <th nzWidth="10%" [nzFilters]="statusFilters" (nzFilterChange)="onFilterChange('status', $event)">Status</th>
          <th nzWidth="10%" nzCustomFilter>
            Data
            <nz-filter-trigger [nzActive]="filterConditions['date']?.length > 0" [nzDropdownMenu]="dateMenu">
              <i nz-icon nzType="filter" nzTheme="fill"></i>
            </nz-filter-trigger>
          </th>
          <th nzWidth="20%" nzCustomFilter>
            Usuário
            <nz-filter-trigger [nzActive]="filterConditions['user']?.length > 0" [nzDropdownMenu]="userMenu">
              <i nz-icon nzType="filter" nzTheme="fill"></i>
            </nz-filter-trigger>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let checklistHeader of checklistHeaderFound; let isLast = last"
          (click)="handleOpenChecklistHeader(checklistHeader?.id)">
          <td>{{ checklistHeader.id }}</td>
          <td>{{ checklistHeader.ProductModel.name }}</td>
          <td>{{ checklistHeader.chassis | uppercase }}</td>
          <td>{{ setTypeName(checklistHeader.type) }}</td>
          <td>
            <nz-tag [nzColor]="setStatusColor(checklistHeader.status).color">
              {{ setStatusColor(checklistHeader.status).text }}
            </nz-tag>
          </td>
          <td>{{ checklistHeader.date | date:'dd/MM/yyyy' }}</td>
          <td>{{ checklistHeader.UserModel.name }}</td>
        </tr>
      </tbody>
    </nz-table>
    <nz-empty [nzNotFoundContent]="'Sem dados cadastrados.'" *ngIf="!checklistHeaderFound.length"></nz-empty>
  </nz-content>
  <nz-footer>
    <nz-pagination #pager [nzPageIndex]="currentPage" [nzPageSize]="currentPageSize"
      (nzPageIndexChange)="onPageChange($event)" (nzPageSizeChange)="onPageSizeChange($event)"
      [nzTotal]="checklistHeaderTotal" nzResponsive="true" nzShowSizeChanger>
    </nz-pagination>
  </nz-footer>
</nz-layout>

<nz-dropdown-menu #dateMenu="nzDropdownMenu">
  <div class="ant-table-filter-dropdown">
    <div style="padding: 8px;">
      <nz-range-picker [(ngModel)]="filterConditions['date']"></nz-range-picker>
    </div>
    <div style="padding: 8px; border-top: 1px solid #eee; display: flex; justify-content: space-between;">
      <button nz-button nzSize="small" nzType="primary" (click)="onFilterChange('date', filterConditions['date'])">
        Filtrar
      </button>
      <button nz-button nzSize="small" (click)="onFilterChange('date', null)">
        Limpar
      </button>
    </div>
  </div>
</nz-dropdown-menu>

<nz-dropdown-menu #userMenu="nzDropdownMenu">
  <div class="ant-table-filter-dropdown">
    <div style="padding: 8px">
      <input nz-input placeholder="Buscar usuário" [(ngModel)]="userSearch" (ngModelChange)="onUserSearch($event)" />
    </div>
    <div style="padding: 8px; max-height: 200px; overflow-y: auto; display: flex; flex-direction: column;">
      <label nz-checkbox *ngFor="let filter of visibleUserFilters" [(ngModel)]="filter.checked">
        {{ filter.text }}
      </label>
    </div>
    <div style="padding: 8px; border-top: 1px solid #eee; display: flex; justify-content: space-between;">
      <button nz-button nzSize="small" nzType="primary" (click)="applyUserFilter()">
        Filtrar
      </button>
      <button nz-button nzSize="small" (click)="clearUserFilter()">
        Limpar
      </button>
    </div>
  </div>
</nz-dropdown-menu>

<nz-dropdown-menu #modelMenu="nzDropdownMenu">
  <div class="ant-table-filter-dropdown">
    <div style="padding: 8px">
      <input nz-input placeholder="Buscar modelo" [(ngModel)]="modelSearch" (ngModelChange)="onModelSearch($event)" />
    </div>
    <div style="padding: 8px; max-height: 200px; overflow-y: auto; display: flex; flex-direction: column;">
      <label nz-checkbox *ngFor="let filter of visibleModelFilters" [(ngModel)]="filter.checked">
        {{ filter.text }}
      </label>
    </div>
    <div style="padding: 8px; border-top: 1px solid #eee; display: flex; justify-content: space-between;">
      <button nz-button nzSize="small" nzType="primary" (click)="applyModelFilter()">
        Filtrar
      </button>
      <button nz-button nzSize="small" (click)="clearModelFilter()">
        Limpar
      </button>
    </div>
  </div>
</nz-dropdown-menu>

<nz-dropdown-menu #chassisMenu="nzDropdownMenu">
  <div class="ant-table-filter-dropdown">
    <div style="padding: 8px">
      <input nz-input placeholder="Buscar chassis" [(ngModel)]="chassisSearch"
        (ngModelChange)="onChassisSearch($event)" />
    </div>
    <div style="padding: 8px; max-height: 200px; overflow-y: auto; display: flex; flex-direction: column;">
      <label nz-checkbox *ngFor="let filter of visibleChassisFilters" [(ngModel)]="filter.checked">
        {{ filter.text }}
      </label>
    </div>
    <div style="padding: 8px; border-top: 1px solid #eee; display: flex; justify-content: space-between;">
      <button nz-button nzSize="small" nzType="primary" (click)="applyChassisFilter()">
        Filtrar
      </button>
      <button nz-button nzSize="small" (click)="clearChassisFilter()">
        Limpar
      </button>
    </div>
  </div>
</nz-dropdown-menu>

<nz-dropdown-menu #idMenu="nzDropdownMenu">
  <div class="ant-table-filter-dropdown">
    <div style="padding: 8px">
      <input nz-input placeholder="Buscar ID" [(ngModel)]="idSearch" (ngModelChange)="onIdSearch($event)" />
    </div>
    <div style="padding: 8px; border-top: 1px solid #eee; display: flex; justify-content: space-between;">
      <button nz-button nzSize="small" nzType="primary" (click)="onIdSearch(idSearch)">
        Filtrar
      </button>
      <button nz-button nzSize="small" (click)="clearIdFilter()">
        Limpar
      </button>
    </div>
  </div>
</nz-dropdown-menu>